<template>
  <div class="plan-dinteressement-wrapper">
    <div v-if="isClientMonthlyPayment" class="row">
      <div class="col-12">
        <div class="page__head-title page__head-title--orange">
          <div class="page__head-title__text page__head-title__text--orange">Plan d’intéressement</div>
        </div>
      </div>

      <div class="col-12">
        <div class="form_ttl_first">
          Plan : <span class="plan_dint_name">{{ planName }}</span>
        </div>
      </div>

      <!-- Range Sliders -->
      <div class="col-12" v-if="!isBusy">
        <div class="range-title">Montant selon la durée de garantie</div>
        <div class="range-group">
          <div class="range-item" v-if="!planLocked">
            <div class="plan-sliders">
              <div class="duration-label" style="opacity: 0;visibility: hidden;">12 mois</div>
              <span class="range-minmax" style="opacity: 0;visibility: hidden;">0 €</span>
              <div class="plan-slider plan-slider-titles plan-slider--active">
                <span class="range-plan-name">{{ planName }}</span>
                <span class="range-plan-message">{{ planMessages[planType] }}</span>
              </div>
              <template v-for="(name, planId) in planNames">
                <div v-if="planId > planType" class="plan-slider plan-slider-titles" :key="planId">
                  <span class="range-plan-name">{{ name }}</span>
                  <span class="range-plan-message">{{ planMessages[planId] }}</span>
                </div>
              </template>
              <div class="num-input" style="opacity: 0;visibility: hidden;">
                <input type="number" class="range-value" :value="0" :min="0" :max="0" :step="0" readonly />
                <span class="range-euro">&nbsp;€</span>
              </div>
            </div>
          </div>
          <div class="range-item" v-for="(duration, idx) in durations" :key="idx">
            <div class="plan-sliders">
              <div class="duration-label">{{ duration }} mois</div>
              <!-- Active plan slider -->
              <span class="range-minmax">{{ minValues[idx] }} €</span>
              <div class="plan-slider plan-slider--active">
                <input type="range" v-model.number="ranges[idx]" :min="minValues[idx]" :max="maxValues[idx]"
                  :step="stepValues[duration]" />
                <span class="range-minmax">{{ maxValues[idx] }} €</span>
              </div>

              <!-- Disabled plan sliders -->
              <div class="plan-slider" v-for="(plan, planId) in planRanges" v-if="(planId > planType) && !planLocked"
                :key="planId">
                <input type="range" :value="getMinForDisabledSlider(planId, duration, idx)"
                  :min="getMinForDisabledSlider(planId, duration, idx)" :max="plan[duration]"
                  :step="stepValues[duration]" disabled />
                <span class="range-max">{{ plan[duration] }} €</span>
              </div>

              <!-- Numeric input -->
              <div class="num-input">
                <input type="number" class="range-value" v-model.number="ranges[idx]" :min="minValues[idx]"
                  :max="maxValues[idx]" :step="stepValues[idx]" @input="clampRange(idx)" readonly />
                <span class="range-euro">&nbsp;€</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <Preloader />
      </div>

      <div class="col-12" v-if="!isBusy">
        <div class="form__item justify-content-center mt-3 mb-3">
          <div class="form__item__submit">
            <input type="button" name="Submit" value="Enregistrer" class="form_bt form__item__submit__button"
              @click="submitPlanDinteressement" />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="row">
      <div class="col-12">
        <div class="page__head-title page__head-title--orange">
          <div class="page__head-title__text page__head-title__text--orange">Plan d’intéressement</div>
        </div>
      </div>
      <div class="col-12 mt-5 mb-5" style="font-size: 18px; color: #888; font-weight: 500;">Cette page n'est pas
        disponible
        pour vous.</div>
    </div>
  </div>
</template>

<script>
import Preloader from '@/components/Preloader';

export default {
  name: 'PlanDinteressement',
  components: { Preloader },
  data() {
    return {
      isBusy: true,
      planLocked: 0,
      planType: 1,
      planName: '',
      planNames: {
        1: 'Affaire',
        2: 'Privilège',
        3: 'Premium'
      },
      planMessages: {
        1: 'Accessible dès le 1er contrat',
        2: 'Accessible dès le 10ème contrat',
        3: 'Accessible dès le 20ème contrat'
      },
      ranges: [0, 0, 0, 0],
      planRanges: {
        1: { // Affaires
          12: 60,
          24: 120,
          36: 180,
          48: 240
        },
        2: { // Privilège
          12: 90,
          24: 180,
          36: 270,
          48: 360
        },
        3: { // Premium
          12: 120,
          24: 240,
          36: 360,
          48: 480
        }
      },
      totalPlans: 3,
      durations: [12, 24, 36, 48],
      minValues: [0, 0, 0, 0],
      maxValues: [60, 120, 180, 240],
      stepValues: {
        12: 10,
        24: 20,
        36: 30,
        48: 40
      }
    };
  },
  methods: {
    getMinForDisabledSlider(planId, duration, currentIdx) {
      // If this is the first plan after the active one, use the active plan's max + 1
      if (planId === this.planType + 1) {
        return this.maxValues[currentIdx] + 1;
      }

      // Otherwise find the previous plan's max value for this duration
      const prevPlanId = planId - 1;
      const prevPlan = this.planRanges[prevPlanId];
      return prevPlan ? prevPlan[duration] + 1 : this.minValues[currentIdx];
    },
    clampRange(idx) {
      const min = this.minValues[idx];
      const max = this.maxValues[idx];
      let val = this.ranges[idx];
      if (val === '' || val === null || val === undefined || isNaN(val)) {
        this.ranges[idx] = 0;
        return;
      }

      if (val < min) val = min;
      if (val > max) val = max;

      const step = this.stepValues[idx];
      val = Math.round(val / step) * step;

      if (val < min) val = min;
      if (val > max) val = max;

      this.ranges[idx] = val;
    },
    submitPlanDinteressement() {
      let url = this.planDinteressementUrl;
      if (!url) return;
      let data = {
        '12month_range_value': this.ranges[0],
        '24month_range_value': this.ranges[1],
        '36month_range_value': this.ranges[2],
        '48month_range_value': this.ranges[3]
      };
      this.apiUpdate(url, data).then(response => {
        this.showSuccessNotification('Le plan d’intéressement a été mis à jour avec succès.');
      }).catch(error => {
        this.showErrorNotification(error);
      });
    }
  },
  computed: {
    isClientMonthlyPayment() {
      return this.$store.getters.isClientMonthlyPayment;
    },
    mechanic() {
      return this.$store.getters.getMechanic;
    },
    representative() {
      return this.$store.getters.getRepresentative;
    },
    planDinteressementUrl() {
      if (this.representative && this.representative.id) {
        return `representatives/${this.representative.id}/plan-dinteressement`;
      }
      if (this.mechanic && this.mechanic.id) {
        return `${this.mechanic.id}/plan-dinteressement`;
      }
      return null;
    }
  },
  created() {
    let url = this.planDinteressementUrl;
    if (url) {
      this.apiGet(url)
        .then(response => {
          if (response.data && response.data.status === 'success' && response.data.planDinteressement) {
            const plan = response.data.planDinteressement;
            // Update the plan type
            this.planType = plan.plan_type;
            // Update plan name
            this.planName = plan.plan_name;
            // Update max values
            const months = [12, 24, 36, 48];
            this.maxValues = months.map(m => plan.range[m.toString()] || 0);
            // Update slider values
            this.ranges = [
              plan['12month_range_value'],
              plan['24month_range_value'],
              plan['36month_range_value'],
              plan['48month_range_value']
            ];
            // Update plan ranges
            this.planRanges = plan.all_ranges;
            // Update plan names
            this.planNames = plan.all_plan_names;
            // Update total plans
            this.totalPlans = plan.total_plans;
            // Update step values
            this.stepValues = plan.steps;
            // Update plan locked
            this.planLocked = plan.plan_lock ? 1 : 0;
          }
          this.isBusy = false;
        })
        .catch(error => {
          this.showErrorNotification(error);
          this.isBusy = false;
        });
    } else {
      this.showWarningNotification('User ID not found');
    }
  }
};
</script>

<style>
input.form__item__submit__button:focus {
  background: #002e5bdd !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PlanDinteressement/PlanDinteressement.vue